"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var GameSetsGamesListCtl = /** @class */ (function (_super) {
    __extends(GameSetsGamesListCtl, _super);
    function GameSetsGamesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key_uid = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key_uid; });
        _this.dk_gameprovider_game_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gameprovider_game_id; });
        _this.dk_brand_gameset_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_gameset_id; });
        _this.dk_game_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.game_title; });
        _this.dk_game_group_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.game_group_title; });
        _this.dk_priority = UIUtils_1.UIUtils.IProp2Str(function (o) { o.priority; });
        _this.dk_is_allowed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_allowed; });
        _this.dk_game_lines_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.game_lines_count; });
        _this.dk_game_icon_full_url = UIUtils_1.UIUtils.IProp2Str(function (o) { o.game_icon_full_url; });
        _this.dk_fs_lines = UIUtils_1.UIUtils.IProp2Str(function (o) { o.fs_lines; });
        _this.dk_fs_bet = UIUtils_1.UIUtils.IProp2Str(function (o) { o.fs_bet; });
        _this.dk_fs_mult = UIUtils_1.UIUtils.IProp2Str(function (o) { o.fs_mult; });
        _this.dk_fs_denom = UIUtils_1.UIUtils.IProp2Str(function (o) { o.fs_denom; });
        _this.dk_fs_tbet = UIUtils_1.UIUtils.IProp2Str(function (o) { o.fs_tbet; });
        _this.dk_game_backend_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.game_backend_code; });
        _this._errDialog = errDialog;
        return _this;
    }
    GameSetsGamesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            groups_filter: [],
            total: 0
        };
    };
    GameSetsGamesListCtl.prototype.getByCmd = function (Cmd) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if ((this.DATA.data[i].brand_gameset_id === Cmd.brand_gameset_id) && (this.DATA.data[i].gameprovider_game_id === Cmd.gameprovider_game_id)) {
                return this.DATA.data[i];
            }
        }
        throw "gameset game with (gameset id) -> [" + Cmd.brand_gameset_id + "] and (gameprovider id) -> [" + Cmd.gameprovider_game_id + "] not found !";
    };
    GameSetsGamesListCtl.prototype.getByConfig = function (Cmd) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if ((this.DATA.data[i].key_uid === Cmd.gameprovider_gameset_game_id)) {
                return this.DATA.data[i];
            }
        }
        throw "gameprovider_gameset_game_id -> [" + Cmd.gameprovider_gameset_game_id + "] not found !";
    };
    GameSetsGamesListCtl.prototype.getGroupsFilter = function () {
        return this.DATA.groups_filter;
    };
    GameSetsGamesListCtl.prototype.LoadData = function (BrandGameSetId, allCurrency, currencyId, onDone) {
        var _this = this;
        webAApi_1.ListAvailGameSetGamesByGameSetIdGet.exec({
            brand_gameset_id: BrandGameSetId,
            all_currencies: allCurrency,
            app_currency_id: currencyId
        }, function (resp) {
            _this.DATA.data = [];
            //
            _this.DATA.groups_filter = [];
            var groups_filter_map = new Map();
            //
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                if (!groups_filter_map.get(resp.list[i].group_title)) {
                    _this.DATA.groups_filter.push({ text: resp.list[i].group_title, value: resp.list[i].group_title });
                    groups_filter_map.set(resp.list[i].group_title, resp.list[i].group_title);
                }
                _this.DATA.data.push({
                    key: "rk-" + BrandGameSetId + "-" + i,
                    key_uid: resp.list[i].key_uid,
                    gameprovider_game_id: resp.list[i].gameprovider_game_id,
                    brand_gameset_id: BrandGameSetId,
                    game_group_title: resp.list[i].group_title,
                    game_title: resp.list[i].title,
                    priority: resp.list[i].priority,
                    is_allowed: resp.list[i].is_allowed,
                    game_icon_full_url: resp.list[i].icon_full_url,
                    game_lines_count: resp.list[i].lines_count,
                    fs_lines: resp.list[i].fs_lines,
                    fs_bet: resp.list[i].fs_bet,
                    fs_mult: resp.list[i].fs_mult,
                    fs_denom: resp.list[i].fs_denom,
                    fs_tbet: resp.list[i].fs_lines * resp.list[i].fs_bet * resp.list[i].fs_denom,
                    game_backend_code: resp.list[i].game_backend_code
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    GameSetsGamesListCtl.prototype.SetGameTemplateIsAllowed = function (data, onDone) {
        var _this = this;
        var _tmp = this.getByCmd(data);
        if (_tmp) {
            webAApi_1.DoSetGameSetGameIsAllowed.exec({
                data: {
                    brand_gameset_id: data.brand_gameset_id,
                    gameprovider_game_id: data.gameprovider_game_id,
                    is_allowed: true
                }
            }, function (resp) {
                _tmp.is_allowed = true;
                _tmp.priority = 0;
                _tmp.key_uid = resp.key_uid;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GameSetsGamesListCtl.prototype.SetAllGameTemplatesIsAllowed = function (gameSetId, onDone) {
        var _this = this;
        webAApi_1.DoSetGameSetAllGamesIsAllowed.exec({
            data: {
                brand_gameset_id: gameSetId,
                is_allowed: true
            }
        }, function (resp) {
            for (var i = 0; i < _this.DATA.data.length; i++) {
                _this.DATA.data[i].is_allowed = true;
                _this.DATA.data[i].priority = 0;
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    GameSetsGamesListCtl.prototype.SetAllGameSetGamesFreeSpinBetLineDenom = function (gameSetId, appCurrencyId, maxFSTbetVal, onDone) {
        var _this = this;
        webAApi_1.DoSetAllGameSetsEqualOrLessFreeSpinTotalBet.exec({
            data: {
                brand_gameset_id: gameSetId,
                app_currency_id: appCurrencyId,
                total_bet_val_eq_or_less: maxFSTbetVal
            }
        }, function (resp) {
            _this.LoadData(gameSetId, false, appCurrencyId, function () {
                if (onDone) {
                    onDone();
                }
            });
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    GameSetsGamesListCtl.prototype.SetGameTemplateIsRejected = function (data, onDone) {
        var _this = this;
        var _tmp = this.getByCmd(data);
        if (_tmp) {
            webAApi_1.DoSetGameSetGameIsAllowed.exec({
                data: {
                    brand_gameset_id: data.brand_gameset_id,
                    gameprovider_game_id: data.gameprovider_game_id,
                    is_allowed: false
                }
            }, function (resp) {
                _tmp.is_allowed = false;
                _tmp.priority = -1;
                _tmp.key_uid = 0;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GameSetsGamesListCtl.prototype.SetAllGameTemplatesIsRejected = function (gameSetId, onDone) {
        var _this = this;
        webAApi_1.DoSetGameSetAllGamesIsAllowed.exec({
            data: {
                brand_gameset_id: gameSetId,
                is_allowed: false
            }
        }, function (resp) {
            for (var i = 0; i < _this.DATA.data.length; i++) {
                _this.DATA.data[i].is_allowed = false;
                _this.DATA.data[i].priority = 0;
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    GameSetsGamesListCtl.prototype.doPlustGameTemplatePriority = function (data, plusPriority, onDone) {
        var _this = this;
        var _tmp = this.getByCmd(data);
        if (_tmp) {
            webAApi_1.DoPlusGameSetGamePriority.exec({
                data: {
                    brand_gameset_id: data.brand_gameset_id,
                    gameprovider_game_id: data.gameprovider_game_id,
                    plus_priority: plusPriority
                }
            }, function (resp) {
                _tmp.priority += plusPriority;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GameSetsGamesListCtl.prototype.doSetGameFreeSpinBet = function (data, freeSpinBet, onDone) {
        var _this = this;
        var _tmp = this.getByConfig(data);
        if (_tmp) {
            webAApi_1.DoSetGameSetGameFreeSpinBet.exec({
                gameprovider_gameset_game_id: data.gameprovider_gameset_game_id,
                freespin_bet: freeSpinBet,
                app_currency_id: data.app_currency_id
            }, function (resp) {
                _tmp.fs_bet = freeSpinBet;
                _tmp.fs_tbet = _tmp.fs_lines * _tmp.fs_bet * _tmp.fs_denom,
                    _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GameSetsGamesListCtl.prototype.doSetGameFreeSpinDenomination = function (data, freeSpinDenomination, onDone) {
        var _this = this;
        var _tmp = this.getByConfig(data);
        if (_tmp) {
            webAApi_1.DoSetGameSetGameFreeSpinDenomination.exec({
                gameprovider_gameset_game_id: data.gameprovider_gameset_game_id,
                freespin_denomination: freeSpinDenomination,
                app_currency_id: data.app_currency_id
            }, function (resp) {
                _tmp.fs_denom = freeSpinDenomination;
                _tmp.fs_tbet = _tmp.fs_lines * _tmp.fs_bet * _tmp.fs_denom,
                    _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GameSetsGamesListCtl.prototype.doSetGameFreeSpinLines = function (data, freeSpinLines, onDone) {
        var _this = this;
        var _tmp = this.getByConfig(data);
        if (_tmp) {
            webAApi_1.DoSetGameSetGameFreeSpinLines.exec({
                gameprovider_gameset_game_id: data.gameprovider_gameset_game_id,
                freespin_lines: freeSpinLines,
                app_currency_id: data.app_currency_id
            }, function (resp) {
                _tmp.fs_lines = freeSpinLines;
                _tmp.fs_tbet = _tmp.fs_lines * _tmp.fs_bet * _tmp.fs_denom,
                    _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GameSetsGamesListCtl.prototype.doSetGameFreeSpinMultiplier = function (data, freeSpinMultiplier, onDone) {
        var _this = this;
        var _tmp = this.getByConfig(data);
        if (_tmp) {
            webAApi_1.DoSetGameSetGameFreeSpinMultiplier.exec({
                gameprovider_gameset_game_id: data.gameprovider_gameset_game_id,
                freespin_multiplier: freeSpinMultiplier,
                app_currency_id: data.app_currency_id
            }, function (resp) {
                _tmp.fs_mult = freeSpinMultiplier;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GameSetsGamesListCtl.prototype.doSetGameFreeSpinLineBetDenom = function (data, line, bet, denom, onDone) {
        var _this = this;
        var _tmp = this.getByConfig(data);
        if (_tmp) {
            webAApi_1.DoSetGameSetGameFSBetLineDenom.exec({
                gameprovider_gameset_game_id: data.gameprovider_gameset_game_id,
                freespin_bet: bet,
                freespin_lines: line,
                freespin_denom: denom,
                app_currency_id: data.app_currency_id
            }, function (resp) {
                _tmp.fs_bet = bet;
                _tmp.fs_lines = line;
                _tmp.fs_denom = denom;
                _tmp.fs_tbet = _tmp.fs_lines * _tmp.fs_bet * _tmp.fs_denom,
                    _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GameSetsGamesListCtl.prototype.doGetGameFreeSpinDetails = function (data, onDone) {
        var _this = this;
        var _tmp = this.getByConfig(data);
        if (_tmp) {
            webAApi_1.DetailGameLinesBetsDenomsByGameSetGameIdGet.exec({
                cms_gameset_game_id: data.gameprovider_gameset_game_id,
                app_currency_id: data.app_currency_id
            }, function (resp) {
                _this.Update();
                if (onDone) {
                    var lines = [];
                    var bets = [];
                    var denoms = [];
                    for (var i = 0; i < resp.lines_list.length; i++) {
                        var tmp = {
                            key: resp.lines_list[i],
                            value: resp.lines_list[i].toString()
                        };
                        lines.push(tmp);
                    }
                    for (var i = 0; i < resp.bets_list.length; i++) {
                        var tmp = {
                            key: resp.bets_list[i],
                            value: resp.bets_list[i].toString()
                        };
                        bets.push(tmp);
                    }
                    for (var i = 0; i < resp.dnms_list.length; i++) {
                        var tmp = {
                            key: resp.dnms_list[i],
                            value: resp.dnms_list[i].toString()
                        };
                        denoms.push(tmp);
                    }
                    onDone(lines, bets, denoms);
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return GameSetsGamesListCtl;
}(BaseController_1.BaseController));
exports.GameSetsGamesListCtl = GameSetsGamesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_gamesets_list/ctl/GameSetGamesListCtl.ts
// module id = 870
// module chunks = 0